import useUserInfo from "../../hooks/useUserInfo";
import {useEffect, useMemo, useRef, useState} from "react";
import Button from "../../ui/Button";
import {EmailLineIcon} from "assets/icon";
import Input from "../../ui/Input";
import Field from "../../ui/Field";
import {EMAIL_CODE_LENGTH, EMAIL_INTERVAL} from "../../config";
import {FormattedMessage, useIntl} from "react-intl";
import {useDownMd} from "../../hooks/useLayout";

export default function StepVerify(props: {
    email: string
    onSuccess?: () => void
}) {
    const intl = useIntl()
    const {getLoginEmailCode, loginByEmail} = useUserInfo()
    const [error, setError] = useState('')
    const [code, setCode] = useState('')
    const [sending, setSending] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const sendTimeRef = useRef(0)
    const [sendBtnText, setSendBtnText] = useState(intl.formatMessage({
        id: "send"
    }))
    const intervalTime = EMAIL_INTERVAL
    const codeLength = EMAIL_CODE_LENGTH
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const isDownMd = useDownMd()

    const onSend = async () => {
        if (sendTimeRef.current > 0) {
            return
        }
        try {
            setError("")
            setSending(true)
            await getLoginEmailCode(props.email)
            sendTimeRef.current = intervalTime
            setSendBtnText(`${sendTimeRef.current}s`)
            intervalRef.current = setInterval(() => {
                sendTimeRef.current--;
                setSendBtnText(`${sendTimeRef.current}s`)
                if (sendTimeRef.current <= 0) {
                    setSendBtnText(intl.formatMessage({
                        id: "resend"
                    }))
                    clearInterval(intervalRef.current!);
                    setSending(false);
                }
            }, 1000);
        } catch (err: any) {
            console.error("Send email error", err)
            setError(intl.formatMessage({
                id: "sendCodeErrorTip",
            }, {error: err.message}))
            setSending(false)
        }

    }
    useEffect(() => {
        onSend()
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, []);
    const canContinue = useMemo(() => {
        return code.length === codeLength
    }, [code])

    const onContinue = async () => {
        if (submitting) {
            return
        }
        try {
            setError("")
            setSubmitting(true)
            const res = await loginByEmail({
                email: props.email,
                code
            })
            if (res) {
                props.onSuccess && props.onSuccess()
            }
            setSubmitting(false)

        } catch (err: any) {
            console.error("Verify email code error", err)
            setError(err.message)
            setSubmitting(false)
        }
    }

    return <div className="matchid-email-verify-box">
        <div className="matchid-email-verify-header">
            <div className="matchid-email-verify-header-icon"><EmailLineIcon size={isDownMd ? 19:24}/></div>
            <div className="matchid-email-verify-header-content">
                <div className="matchid-email-verify-header-value">{props.email}</div>
                <div className="matchid-email-verify-header-tips"><FormattedMessage id="sendEmailTips"/></div>
            </div>
        </div>
        <Field label={intl.formatMessage({
            id:"verificationCode"
        })} error={error}>
            <Input
                placeholder={intl.formatMessage({
                    id:"codePlaceholder"
                })}
                className={"matchid-email-verify-field"}
                maxLength={codeLength}
                onChange={e => setCode(e.target.value)}
                value={code}
                after={<Button
                    highlight
                    disabled={sending}
                    style={{
                        height: '100%',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderTopRightRadius: 'inherit',
                        borderBottomRightRadius: 'inherit',
                        width: "80px"
                    }}
                    onClick={onSend}>{sendBtnText}</Button>}
            >

            </Input>
        </Field>

        <Button disabled={!canContinue} loading={submitting} highlight block size="lg" onClick={onContinue}><FormattedMessage id={"continue"}/></Button>
    </div>
}